

































import { Vue, Prop, Component, Watch } from "vue-property-decorator";
@Component({
  components: {}
})
export default class Grade extends Vue {
  tableData = [
    {
      tit1: "行业ICT认证",
      tit2: "Finance",
      tit3: "HCIA-Finance",
      tit4: "——",
      tit5: "——"
    },
    {
      tit1: "行业ICT认证",
      tit2: "Public Safety",
      tit3: "HCIA-Public Safety",
      tit4: "HCIP-Public Safety",
      tit5: "——"
    },
    // 平台与服务认证
    {
      tit1: "平台与服务认证",
      tit2: "Big Data",
      tit3: "HCIA- Big Data",
      tit4: "HCIP-Big Data Developer",
      tit5: "HCIE- Big Data-Data Mining"
    },
    {
      tit1: "平台与服务认证",
      tit2: "AI",
      tit3: "HCIA-AI",
      tit4: "HCIP-AI HiAl Developer",
      tit5: "5"
    },
    {
      tit1: "平台与服务认证",
      tit2: "AI",
      tit3: "HCIA-AI",
      tit4: "HCIP-AI EI Developer",
      tit5: "5"
    },
    {
      tit1: "平台与服务认证",
      tit2: "loT",
      tit3: "HCIA-IoT",
      tit4: "HCIP-IoT Developer",
      tit5: "——"
    },
    {
      tit1: "平台与服务认证",
      tit2: "Enterprise",
      tit3: "HCIA-Unified Communication",
      tit4: "HCIP-Unified Communication",
      tit5: "HCIE-Enterprise Communication"
    },
    {
      tit1: "平台与服务认证",
      tit2: "Communication",
      tit3: "HCIA-Video Conference",
      tit4: "HCIP-Video Conference",
      tit5: "HCIE-Enterprise Communication"
    },
    {
      tit1: "平台与服务认证",
      tit2: "Communication",
      tit3: "HCIA-Contact Center",
      tit4: "HCIP-Contact Center",
      tit5: "——"
    },
    {
      tit1: "平台与服务认证",
      tit2: "Cloud Service",
      tit3: "HCIA-Cloud Service",
      tit4: "HCIP-Cloud Service Solutions Architect",
      tit5: "5"
    },
    {
      tit1: "平台与服务认证",
      tit2: "Cloud Service",
      tit3: "HCIA-Cloud Service",
      tit4: "HCIP-Cloud Service Developer",
      tit5: "5"
    },
    {
      tit1: "平台与服务认证",
      tit2: "Cloud Computing",
      tit3: "HCIA-Cloud Computing",
      tit4: "HCIP-Cloud Computing",
      tit5: "HCIE-Cloud Computing"
    },
    {
      tit1: "平台与服务认证",
      tit2: "Cloud Computing",
      tit3: "HCIA-Cloud Computing",
      tit4: "HCIP-Cloud Computing-OpenStack",
      tit5: "HCIE-Cloud Computing"
    },
    {
      tit1: "平台与服务认证",
      tit2: "Cloud Computing",
      tit3: "HCIA-Cloud Computing",
      tit4: "HCIP-Cloud Computing-Container",
      tit5: "HCIE-Cloud Computing"
    },
    {
      tit1: "平台与服务认证",
      tit2: "Cloud Computing",
      tit3: "HCIA-Cloud Computing",
      tit4: "HCIP-Cloud Computing-Container",
      tit5: "HCIE- Cloud Computing"
    },
    // ICT技术架构认证
    {
      tit1: "ICT技术架构认证",
      tit2: "Data Center",
      tit3: "HCIA-Data Center",
      tit4: "HCIP-Data Center",
      tit5: "HCIE- Big Data-Data Mining"
    },
    {
      tit1: "ICT技术架构认证",
      tit2: "Data Center",
      tit3: "HCIA-Data Center Facility",
      tit4: "HCIP-Data Center Facility Deployment",
      tit5: "5"
    },
    {
      tit1: "ICT技术架构认证",
      tit2: "Data Center",
      tit3: "HCIA-Data Center Facility",
      tit4: "HCIP-Data Center Facility Operation & Maintenance",
      tit5: "5"
    },
    {
      tit1: "ICT技术架构认证",
      tit2: "Storage",
      tit3: "HCIA-Storage",
      tit4: "HCIP-Storage",
      tit5: "HCIE-Storage"
    },
    {
      tit1: "ICT技术架构认证",
      tit2: "Intelligent Computing",
      tit3: "HCIA-Intelligent Computing",
      tit4: "HCIP-Intelligent Computing",
      tit5: "——"
    },
    {
      tit1: "ICT技术架构认证",
      tit2: "Routing & Switching",
      tit3: "HCIA-Routing & Switching",
      tit4: "HCIP-Routing & Switching",
      tit5: "HCIE-Routing & Switching"
    },
    {
      tit1: "ICT技术架构认证",
      tit2: "Routing & Switching",
      tit3: "HCIA-Routing & Switching",
      tit4: "HCIP-Carrier IP",
      tit5: "HCIE-Carrier IP"
    },
    {
      tit1: "ICT技术架构认证",
      tit2: "WLAN",
      tit3: "HCIA-WLAN",
      tit4: "HCIP-WLAN",
      tit5: "——"
    },
    {
      tit1: "ICT技术架构认证",
      tit2: "Security",
      tit3: "HCIA-Security",
      tit4: "HCIP-Security",
      tit5: "HCIE-Security"
    },
    {
      tit1: "ICT技术架构认证",
      tit2: "SDN",
      tit3: "HCIA-SDN",
      tit4: "HCIP-SDN",
      tit5: "——"
    },
    {
      tit1: "ICT技术架构认证",
      tit2: "Transmission",
      tit3: "HCIA-Transmission",
      tit4: "HCIP-Transmission",
      tit5: "HCIE-Transmission"
    },
    {
      tit1: "ICT技术架构认证",
      tit2: "Access",
      tit3: "HCIA-Access",
      tit4: "HCIP-Access",
      tit5: "——"
    },
    {
      tit1: "ICT技术架构认证",
      tit2: "LTE",
      tit3: "HCIA-LTE",
      tit4: "HCIP-LTE",
      tit5: "——"
    },
    {
      tit1: "ICT技术架构认证",
      tit2: "LTE",
      tit3: "HCIA-LTE-RNP&RNO",
      tit4: "HCIP-LTE-RNP&RNO",
      tit5: "——"
    },
    {
      tit1: "ICT技术架构认证",
      tit2: "5G",
      tit3: "HCIA-5G",
      tit4: "——",
      tit5: "——"
    },
    {
      tit1: "ICT技术架构认证",
      tit2: "5G",
      tit3: "HCIA-5G-RAN",
      tit4: "HCIP-5G-RAN",
      tit5: "——"
    },
    {
      tit1: "ICT技术架构认证",
      tit2: "5G",
      tit3: "HCIA-5G-RNP&RNO",
      tit4: "HCIP-5G-RNP&RNO",
      tit5: "——"
    },
    {
      tit1: "ICT技术架构认证",
      tit2: "5G",
      tit3: "HCIA-5G-Bearer",
      tit4: "——",
      tit5: "——"
    },
    {
      tit1: "ICT技术架构认证",
      tit2: "5G",
      tit3: "HCIA-5G-Core",
      tit4: "——",
      tit5: "——"
    }
  ];
  columns = [
    {
      field: "tit1",
      title: "技术领域",
      width: 150,
      titleAlign: "center",
      columnAlign: "left"
    },
    {
      field: "tit2",
      title: "技术方向",
      width: 200,
      titleAlign: "center",
      columnAlign: "left"
    },
    {
      field: "tit3",
      title: "HCIA工程师",
      width: 240,
      titleAlign: "center",
      columnAlign: "left"
    },
    {
      field: "tit4",
      title: "HCIP高级工程师",
      width: 310,
      titleAlign: "center",
      columnAlign: "left"
    },
    {
      field: "tit5",
      title: "HCIE专家",
      width: 260,
      titleAlign: "center",
      columnAlign: "left"
    }
  ];
}
